import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';

export function NotFound() {
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center gap-3 text-center">
      <div className="gradient-brand-text font-display text-5xl font-extrabold">404</div>
      <h2 className="font-heading text-xl">That page doesn't exist.</h2>
      <p className="text-sm text-muted-foreground">Check the URL, or return to the dashboard.</p>
      <Button asChild variant="default" className="mt-2">
        <Link to="/dashboard">Go to dashboard</Link>
      </Button>
    </div>
  );
}
